<template>
  <div :data-testid="TEST_ID.FORO_REPLY_FORM.ROOT">
    <div class="user" :data-testid="TEST_ID.FORO_REPLY_FORM.USERNAME">{{nombreCompleto}}</div>
    <div class="fecha" :data-testid="TEST_ID.FORO_REPLY_FORM.DATE">{{fechaStr}}</div>
    
    <div class="body_comentario">
      <div :data-testid="TEST_ID.FORO_REPLY_FORM.TEXTAREA">
        <el-input
          class="textarea"
          type="textarea"
          :rows="4"
          :placeholder="this.$t('FORO_comentario_placeholder')"
          v-model="respuesta.Comentario">
        </el-input>
      </div>

      <div v-if="permitirImagenes" class="upload">
        <FileUpload 
          :files="this.respuesta.Imagenes"
          :storeAction="'foro/uploadImagenComentario'"
          :temporalId="idTemporal"
          :onFileListChange="onImagenesChanged" 
          :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
          :limit="20"
          :multiple="true"
          :cargandoArchivo="cargando"
          :foro="true"
          :buttonTestId="TEST_ID.FORO_REPLY_FORM.BUTTON_UPLOAD_IMAGE"
        />
      </div>
    </div>

    <div class="leave_comment__btns">
      <el-button 
        :data-testid="TEST_ID.FORO_REPLY_FORM.BUTTON_SUBMIT"
        type="primary" 
        size="small"
        @click="guardarComentario"
        :loading="loading"
        :disabled="cargaArchivo"
      >
        {{ esRespuesta ? this.$t('FORO_responder') : this.$t('FORO_comentar')}}
      </el-button>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ElMessageBox } from 'element-plus'
import FileUpload from '../FileUpload/index'
import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado'
import { showError, showSuccess } from '../Mensaje'
import TEST_ID from '@/testIds.json'

export default {
  name: 'RespuestaComentarioForo',
  props: { 
    esRespuesta: Boolean,
    idForo: Number,
    idComentario: Number,
    afterSave: Function,
    permitirImagenes: Boolean, 
  },
  components: { FileUpload },
  data() {
    return {
      TEST_ID,
      respuesta: {
        IdForo: this.idForo,
        IdComentarioPadre: this.idComentario,
        Comentario: "",
        Imagenes: [],
        Fecha: new Date()
      },

      cargaArchivo: false,
      idTemporal: (new Date()).getTime().toString(),
      loading: false
    }
  },
  computed: {
    fechaStr() {
      let fecha = this.respuesta.Fecha
      return `${fecha.getDate()}/${(fecha.getMonth() + 1).toString().padStart(2, '0')}/${fecha.getFullYear()}`
    },
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      nombreCompleto: state => state.sesion.resultadoAutenticacion.NombreCompleto
    })
  },
  methods: {
    cargando(value) {
        this.cargaArchivo = value;
      },

    handleExceed(files, fileList) {
      showError(this.$t('GENERAL_img_upload_limit')`${files.length + fileList.length}`)
    },

    beforeRemove(file) {
      return ElMessageBox.confirm(
        this.$t('GENERAL_img_remove_confirm')`${file.name}?`,
        this.$t('GENERAL_atencion'),
        { type: 'warning' }
      )
    },

    handleError() {
      showError(this.$t('GENERAL_img_upload_error'))
    },

    onImagenesChanged(name, fileList) {
      this.respuesta.Imagenes = fileList//.map((x) => { return { name: x.value } })
    },

    guardarComentario() {

      this.loading = true

      // validaciones
      let valida = true

      this.respuesta.Comentario = this.respuesta.Comentario.trim()
      if(this.respuesta.Comentario === "")
      {
        showError(this.$t('FORO_comentario_missing'))
        valida = false
      }

      if(!valida) {
        this.loading = false
        return
      }

      // armo el payload
      let payload = {
        Id: 0,
        IdEntradaForo: this.respuesta.IdForo,
        IdComentarioPadre: this.respuesta.IdComentarioPadre,
        IdUsuario: this.idUsuario,
        NombreUsuario: this.nombreCompleto,
        Comentario: this.respuesta.Comentario,
        Imagenes: this.respuesta.Imagenes.map((x) => { return x.name }),
        IdCarpetaTemporal: this.idTemporal
      }

      // guardo el comentario
      this.$store.dispatch('foro/saveComentario', payload)
      .then(data => { 
        
        if(data.CodigoResultado === 0)
        {
          showSuccess(this.$t('FORO_comentario_exito'))
          this.limpiarComponente()
          this.afterSave(JSON.parse(data.Datos))
        }
        else
          mostrarMensajeInternacionalizado(data.CodigoResultado)
      })
      .finally(() => this.loading = false)
    },

    limpiarComponente() {
        this.respuesta = { ... this.respuesta }
        this.respuesta.Comentario = ""
        this.respuesta.Imagenes = []
      }
  }
}
</script>

<style scoped>
  .user {
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    color: var(--main-color);
    float: left;
    margin-bottom: 10px;
  }
  .fecha {
    font-size: 14px;
    line-height: 16px;
    float: right;
  }
  .body_comentario {
    clear: both;
    font-size: 16px;
    line-height: 19px;
    color: #6F6F6F;
    text-align: left;
    display: inline-block;
    width: 100%;
  }
  .textarea {
    width: 60%;
    float: left;
  }
  
  .upload {
    position: relative;
    left: 20px;
    float: right;
    width: 40%;
  }
  .leave_comment__btns {
    text-align: left;
    margin-top: 20px;
  }
</style>

<style>

  .textarea > textarea {
    height: 125px;
  }

</style>

